import { JhiAlertService } from 'ng-jhipster/src/service/alert.service';

import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { BreadcrumbStep } from '../shared/components/breadcrumb/breadcrumb.model';
import { depotRequeteSteps } from './depot-requete.data';
import { DraftDepotRequeteService } from './draft-depot-requete.service';

@Component({
    selector: 'jhi-depot-requete',
    templateUrl: './depot-requete.component.html',
    styleUrls: ['./depot-requete.component.scss']
})
export class DepotRequeteComponent {
    steps: Array<BreadcrumbStep> = depotRequeteSteps.map((step, index) => ({
        label: step.breadTitle,
        route: `/${step.fullRoute}`,
        isActive: index === this.getActiveStepIndex()
    }));

    public isRetakenDraft = false;
    private autoSaveTime: any;
    private draftCreationDate: string;
    public dateAndHour: string[];

    constructor(
        private router: Router,
        private alertService: JhiAlertService,
        private draftDepotRequeteService: DraftDepotRequeteService
    ) {
        this.hideAlertDraft();
        this.draftDepotRequeteService.getMyDraftRequeteSummary().subscribe(draftSummary => {
            if (draftSummary) {
                // cacher temporairement suite au commentaire fait le 30/10/2023 dans TRC-629, à rétablir plus tard
                this.isRetakenDraft = false;
                this.draftCreationDate = this.draftDepotRequeteService.depotRequeteState.dateCreation.toString();
                this.dateAndHour = this.draftDepotRequeteService.convertCreationDateToDateAndHour(this.draftCreationDate);

                setTimeout(() => {
                    this.isRetakenDraft = false;
                }, 15000);

            }
        });
        this.draftDepotRequeteService.data$.subscribe(data => {
            this.autoSaveTime = data;
          });
    }

    // When a component is loaded, onActivate will be triggered
    // and we will get the component reference
    // and can access all functions using that
    onActivate(childComponent) {
        let methodNames = [
            'previousStep',
            'nextStep',
            'hideAlertDraft',
            'showErrorAlertDraft',
            'showSuccessAlertDraft',
            'showAutoSaveSuccessAlertDraft'
        ];

        // Define which method is called when the child emits one of its EventEmitter
        let methods = methodNames.reduce((map, currentMethodName) => {
            map.set(currentMethodName, this[currentMethodName].bind(this));
            return map;
        }, new Map<string, Function>());

        methods.forEach((method, methodName) => {
            // If the component has a property corresponding to one of the known event-emitter,
            // subscribe the corresponding handler to the property.
            if (methodName in childComponent) {
                childComponent[methodName].subscribe(method);
            }
        });
    }

    private hideAlertDraft(): void {
        this.alertService.clear();
    }

    // @ts-ignore method is used as subscriber in onActivate
    private showErrorAlertDraft(): void {
        this.alertService.addAlert({ type: 'danger', msg: 'draft.error' }, []);
    }

    // @ts-ignore method is used as subscriber in onActivate
    private showSuccessAlertDraft(): void {
        this.alertService.addAlert({type: 'success', msg: 'draft.success', timeout: 300000 }, []);
    }

    // @ts-ignore method is used as subscriber in onActivate
    private showAutoSaveSuccessAlertDraft(): void {
        this.alertService.addAlert({type: 'success', msg: 'draft.autoSaveSuccess',
                                    params: {param: this.autoSaveTime}, timeout: 30000 }, []);
    }

    // @ts-ignore method is used as subscriber in onActivate
    private nextStep(): void {
        let activeStepIndex = this.getActiveStepIndex();
        this.navigateToStepByIndex(activeStepIndex + 1);
    }

    // @ts-ignore method is used as subscriber in onActivate
    private previousStep(): void {
        let activeStepIndex = this.getActiveStepIndex();
        this.navigateToStepByIndex(activeStepIndex - 1);
    }

    // @ts-ignore method is used as subscriber in onActivate
    private getActiveStepIndex(): number {
        return depotRequeteSteps.findIndex(stepDetail => this.router.isActive(`${stepDetail.fullRoute}`, true));
    }

    private navigateToStepByIndex(index: number): void {
        if (depotRequeteSteps[index]) {
            this.router.navigate([depotRequeteSteps[index].fullRoute]);
        } else if (index < 0) {
            this.router.navigate(['/accueil']);
        }
    }

    close() {
        this.isRetakenDraft = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/depot-requete.component.ts